import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

export const freshRun = createSlice({
  name: 'freshRun',
  initialState: {
    value: true
  },
  reducers: {
    assignFreshRun: (state, action) => {
      state.value = action.payload;
      saveState("freshRun", state);
    }
  }
})

// Action creators are generated for each case reducer function
export const { assignFreshRun } = freshRun.actions

export default freshRun.reducer